module.exports = __webpack_public_path__ + "static/media/search.e6f67825.svg";